export enum StorageEnum {
  prefix = 'GABRIEL-LIMA',
  primaryColor = 'PRIMARY-COLOR',
  theme = 'THEME',
  gists = 'GISTS'
}
